import navTreatments from "./nav-treatments.json";

// Contact details, social links and navigation, lifted out of the hand-written
// markup in header.php / footer.php so they live in one place.

export const contact = {
  phone: "+91 9540210956",
  phoneHref: "tel:+919540210956",
  whatsapp: "https://wa.me/+919540210956",
  email: "info@chestsurgeryindia.com",
  address: "Artemis Hospital Sector 51 Gurgaon",
  hours: "09Am - 5Pm",
};

export const social = [
  { href: "https://www.facebook.com/chestsurgeryindia", icon: "icofont-facebook", label: "Facebook" },
  { href: "https://www.youtube.com/channel/UCDvfENuMQ0841MXB2iUOmbw", icon: "icofont-youtube-play", label: "YouTube" },
  { href: "https://www.linkedin.com/company/chest-surgery-india/", icon: "icofont-linkedin", label: "LinkedIn" },
  { href: "https://www.instagram.com/chestsurgeryindia/", icon: "icofont-instagram", label: "Instagram" },
  { href: "https://twitter.com/drparveenyadav7", icon: "icofont-twitter", label: "Twitter" },
];

export type NavItem = {
  label: string;
  href?: string;
  children?: NavItem[];
};

// Generated from the `treatments` collection by scripts/generate-nav.mjs, which
// runs before `next dev` and `next build`. Editing this list by hand has no
// effect — change navLabel / parent / order on the CMS entries instead.
export const treatments: NavItem[] = navTreatments as NavItem[];

export const mainNav: NavItem[] = [
  { label: "Home", href: "/" },
  { label: "About Doctor", href: "/about" },
  { label: "Treatments", children: treatments },
  { label: "Patient Education", href: "/video" },
  { label: "Gallery", href: "/gallery" },
  { label: "Blog", href: "/blog" },
  { label: "Contact Us", href: "/contact" },
];

export const footerQuickLinks: NavItem[] = [
  { label: "About Doctor", href: "/about" },
  { label: "Patient Education", href: "/video" },
  { label: "Gallery", href: "/gallery" },
  { label: "Blog", href: "/blog" },
  { label: "Contact us", href: "/contact" },
  { label: "GET FREE SECOND OPINION", href: "/second-opinion-thoracic-surgeon-india" },
];

/**
 * Footer treatment column — the shorter list the original footer showed. It is
 * deliberately NOT generated from the CMS: it omits Bullous Disease and Upper
 * Thorax and labels lung cancer "LUNG", so deriving it from the nav would
 * silently change the footer. Add new treatments here by hand if they should
 * also appear in the footer.
 */
export const footerTreatments: NavItem[] = [
  { label: "ESOPHAGEAL", href: "/esophageal-cancer-treatment-gurgaon" },
  { label: "LUNG", href: "/lungs-cancer-treatment-gurgaon" },
  { label: "TRACHEAL", href: "/tracheal-cancer-treatment-gurgaon" },
  { label: "CHEST WALL", href: "/chest-wall-tumor-surgery-gurgaon" },
  { label: "MEDIASTINAL MASS", href: "/mediastinal-tumor-treatment-gurgaon" },
  { label: "EMPYEMA", href: "/empyema-treatment-gurgaon" },
  { label: "BRONCHOPLEURAL FISTULA", href: "/bronchopleural-fistula-treatment-gurgaon" },
];

export const analytics = {
  clarityId: "ms9du2bdgs",
  // head.php loaded gtag twice with two different measurement IDs.
  gaIds: ["G-EVF47LET5J", "G-FL1R2XBXQ1"],
  ahrefsKey: "RYDS/0McZGTn+hWtDyrCoA",
  googleSiteVerification: "xrPs3Hn9DEsd1L0M3MI5iVltToV7IayPhRem4dkPuIg",
  hubspot: { portalId: "49050099", formId: "626ba56d-fc2b-464b-b43d-71a2413ef7fa" },
};
